(function () {
  'use strict';

  angular.module('estClipboard', []);
})();
